module.exports = __webpack_public_path__ + "static/media/fonts-1.7663a00f.svg";